module.exports = __webpack_public_path__ + "img/simple-wage-payment.b835f5c0.svg";